import { Component, ViewChild } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';

import {AutoCompleteComponent} from 'ionic2-auto-complete';
import { SaldosPage } from '../saldos/saldos';
import { ComprobantesPage } from '../comprobantes/comprobantes';
import { DocumentoPage } from '../documento/documento';

import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import { EntidadServiceProvider} from '../../providers/entidad-service/entidad-service';
import { CarteraServiceProvider } from '../../providers/cartera-service/cartera-service';
import { DocumentoServiceProvider } from '../../providers/documento-service/documento-service';
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  @ViewChild('proveedor') proveedor: AutoCompleteComponent
  departamentos: any=[] ;
  entidad={ ndepartamento:0, deuda:0};
  ndocumento=0;
  pageDocuments: any;
  constructor(public navCtrl: NavController, public auth: AuthServiceProvider, 
    public carteraProvider: CarteraServiceProvider, public entidadService: EntidadServiceProvider,
    public documentoService: DocumentoServiceProvider,
    private translateService: TranslateService, public alertCtrl: AlertController) {
    this.entidadService.idtentidad = 2; //CONDOMINOS
    
    this.pageDocuments = DocumentoPage;
  }

  seleccionarIdioma(){
    let alert = this.alertCtrl.create();
    alert.setTitle('Select a language');

    alert.addInput({
      type: 'radio',
      label: 'English',
      value: 'en',
      checked: true
    });

    alert.addInput({
      type: 'radio',
      label: 'Español',
      value: 'es'
    });
    
    alert.addButton('Cancel');
    alert.addButton({
      text: 'OK',
      handler: data => {
        this.translateService.use(data);
      }
    });
    alert.present();
  }

  ionViewDidLoad() {
    if(this.auth.usuario.identidad != null && this.auth.usuario.identidad != 0){
      this.consultar(this.auth.usuario.identidad);
    }
    this.documentoService.buscar(-1, 2).then(data => {
      let documento:any = data;
      this.ndocumento = documento.length;
    });
  }

  consultar(identidad){
      this.carteraProvider.getReporte(1, identidad).then(data=>{     
          //console.log(data); 
          this.departamentos=data;
          this.entidad.ndepartamento = this.departamentos.length;
          this.entidad.deuda=0;
          for (var i = 0; i < this.departamentos.length; ++i) {
            this.departamentos[i]['saldo'] = parseFloat(this.departamentos[i]['saldo'] == null ? 0 : this.departamentos[i]['saldo']);
            this.entidad.deuda += parseFloat(this.departamentos[i]['saldo']);
          }
        },(err) => {
      })
  }

  itemClick(evento, item)
  {
    if( parseFloat(item['saldo']) > 0){
      window.open(this.carteraProvider.serverServicios + "/departamento"+ item.id +".pdf", "_blank");
    }
  }

  abrirDropbox(){
    //[navPush]="pageDocuments"
    window.open("https://www.dropbox.com/sh/f3yyy2joxbh1xde/AABKYCSjyvaLxdwyZx2h14cTa?dl=0", "_blank");
  }

  saldos() {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.navCtrl.setRoot(SaldosPage);
  }

  comprobantes() {
    this.navCtrl.setRoot(ComprobantesPage);
  }

  seleccionarProveedor(evento)
  {
    
    let descripcion = evento.descripcion;
    if(this.auth.usuario.idtentidad != 1){
      this.proveedor.setValue(descripcion);
      this.consultar(evento.id);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts